// extracted by mini-css-extract-plugin
export var numberDisplay = "itemsInCart-module--numberDisplay--9xEAb";